__turbopack_context__.v({
  "wrapper": "sort-section-module-scss-module__sqE3Gq__wrapper",
});
